import {getUserPermissions} from './getUserPermissions'

export const permissions = {
  getUserPermissions,
}
